<template>
  <div>
    <el-row>
      <el-col :span="5" style="max-width: 160px">
        <label
          v-if="mode !== 'form'"
          class="has-text-grey"
          style="vertical-align: middle; margin-left: 1.6em; margin-bottom: 2em; fontsize: 14px"
        >
          {{ setting.label || name }}
          <Tooltip :label="setting.label || name" :content="setting.detail" />
        </label>
      </el-col>
      <el-col :span="23" style="max-width: 540px; margin-left: 0.5em">
        <el-input
          v-model="value[name]"
          type="textarea"
          :placeholder="setting.placeholder"
          :autosize="{ minRows: 4 }"
          :required="setting.required"
          style="margin-bottom: 1em"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
/**
 * Textarea SmartField - Renders a multi-line text input for string configuration values.
 *
 * @component
 * @description Displays a resizable textarea with auto-sizing (minimum 4 rows).
 * Useful for longer text inputs like descriptions, templates, or messages.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the textarea (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {string} [setting.placeholder] - Placeholder text for the textarea
 * @prop {boolean} [setting.required] - If true, marks the textarea as required
 * @prop {string} [setting.default] - Default value if not set
 * @prop {string} name - Property key in the value object
 * @prop {string} [mode] - Display mode ('form' hides label)
 *
 * @example
 * <Textarea
 *   :value="config"
 *   :setting="{
 *     label: 'Description',
 *     detail: 'Enter a detailed description',
 *     placeholder: 'Type here...'
 *   }"
 *   name="description"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name", "mode"],
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
